export const Roles = {
  SAAS_ADMIN: 'SAAS_ADMIN',
  TENANT_ADMIN: 'TENANT_ADMIN',
  SRE: 'SRE'
};

export const CognitoGroupRole = {
  SAAS: 'saas_admin',
  TENANT: 'tenant_admin'
};
